import { createAction, props } from '@ngrx/store';
import { IDeferralAcceptNewDateRequestBody } from 'src/app/my-bill/models/deferral.model';

export const DEFERRAL_REQUEST = 'DEFERRAL_REQUEST';
export const DEFERRAL_SUCCESS = 'DEFERRAL_SUCCESS';
export const DEFERRAL_FAILURE = 'DEFERRAL_FAILURE';
export const RESET_DEFERRAL_DATA = 'RESET_DEFERRAL_DATA';

export const deferralRequest = createAction(
  DEFERRAL_REQUEST,
  props<{
    paNumber: string;
    invoiceReference: string;
    requestBody: IDeferralAcceptNewDateRequestBody;
  }>()
);
export const deferralSuccess = createAction(DEFERRAL_SUCCESS);
export const deferralFailure = createAction(DEFERRAL_FAILURE);
export const resetDeferralData = createAction(RESET_DEFERRAL_DATA);
